// Service page content for Visa Refusals (review at the ART).
// Sourced from docs/research/australian-visa-pathways.md §9.
// COMPLIANCE: our role is narrow and clerical, read the letter with you, flag
// the deadline, get you to a registered migration agent fast, and gather their
// documents. A registered migration agent confirms review rights, lodges, and
// represents you (judicial review is a lawyer's domain). No guarantees; honest
// that the ART decides, time limits are strict, and appeals are not a quick
// fix; no unverified figures as fact.

const visaRefusals = {
  groupSlug: "review-appeals",
  slug: "visa-refusals",
  title: "Visa Refusals",
  eyebrow: "Review & Appeals",
  intro:
    "A visa refusal is not always the end of the road. Many refusals can be reviewed by the Administrative Review Tribunal (ART), which can re-make the decision on its merits. The catch is that the time limit to apply is short and strict, so the most important thing you can do is act quickly. We read the letter with you, flag the deadline, and get you to a registered migration agent fast, then gather the documents they need. A registered migration agent confirms your review rights, lodges, and represents you.",

  chips: [
    { label: "What it is", value: "Merits review at the ART" },
    { label: "Decided by", value: "The ART (independent)" },
    { label: "Time limit", value: "Short and strict" },
    { label: "If it fails", value: "Judicial review or Ministerial request" },
  ],

  whoFor: [
    "People whose visa application has been refused by the Department.",
    "Sponsors or nominators who can seek review of certain decisions.",
    "Anyone who has just received a refusal letter and needs to act fast.",
  ],

  essentials: [
    {
      title: "Check if the decision is reviewable",
      detail:
        "The ART reviews many, but not all, refusals. Some offshore refusals and decisions made personally by the Minister are not reviewable. A registered migration agent confirms whether yours is.",
    },
    {
      title: "Strict time limits",
      detail:
        "The window to lodge is short, often around 21 to 28 days depending on the decision. Missing it usually ends the review right, so do not sit on a refusal letter.",
    },
    {
      title: "Who can apply",
      detail:
        "Depending on the decision, the applicant or the Australian sponsor or nominator may be the one entitled to seek review.",
    },
    {
      title: "Merits review",
      detail:
        "The ART can look at the facts and law afresh and re-make the decision, not just check for legal error.",
    },
    {
      title: "An application fee",
      detail:
        "A Tribunal fee applies, set by the ART, with a partial reduction available in defined circumstances. A registered migration agent confirms the current fee for you.",
    },
    {
      title: "It is not a quick fix",
      detail:
        "There is a significant backlog, and many reviews take well over a year. We are honest about the timeline from the start.",
    },
  ],

  process: [
    {
      title: "Read the refusal with you, urgently",
      detail:
        "We read your refusal letter with you immediately, flag the exact deadline, and get you to a registered migration agent fast.",
    },
    {
      title: "Confirm review rights",
      detail:
        "A registered migration agent confirms whether the decision is reviewable and who is entitled to apply.",
    },
    {
      title: "Lodge in time",
      detail:
        "A registered migration agent lodges the review application within the strict time limit. We chase the documents so nothing stalls.",
    },
    {
      title: "Build the case",
      detail:
        "We gather and organise the evidence, and a registered migration agent prepares the submissions for the Tribunal.",
    },
    {
      title: "Representation at review",
      detail:
        "A registered migration agent represents you through to the hearing and the Tribunal's decision. We keep the documents moving and keep you informed.",
    },
    {
      title: "Next steps",
      detail:
        "If the ART affirms the refusal, a registered migration agent, or a lawyer for judicial review, advises on the limited further options.",
    },
  ],

  faqs: [
    {
      q: "How long do I have to appeal a refusal?",
      a: "Not long. The time limit is short and strict, commonly around 21 to 28 days from the decision depending on the type. Missing it usually ends your right to review, so contact us as soon as you receive a refusal and we get you to a registered migration agent fast.",
    },
    {
      q: "Can you guarantee the refusal will be overturned?",
      a: "No. The ART is an independent tribunal that decides on the merits, and no one can guarantee the result. Our part is to read the letter with you, flag the deadline, get you to a registered migration agent fast, and gather the documents. A registered migration agent confirms your review rights, lodges in time, and puts the case forward.",
    },
    {
      q: "How long does a review take?",
      a: "Honestly, often a long time. There is a large backlog and many migration reviews take well over a year, sometimes several. We are upfront about this so an appeal is not mistaken for a quick fix.",
    },
    {
      q: "What if the ART agrees with the refusal?",
      a: "There are limited further options, such as judicial review in the courts for legal error, or a discretionary request for Ministerial intervention. These are last resorts with their own strict rules. A registered migration agent, or a lawyer for judicial review, advises on them.",
    },
  ],

  related: ["visa-cancellations", "partner-visa", "student-500"],

  lastVerified: "13 July 2026",
};

export default visaRefusals;
